<div class="modal fade" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-xl modal-dialog-centered" style="height: 90vh;">
    <div class="modal-content d-flex flex-column h-100 p-0">
      <!-- Header fijo -->
      <div class="modal-header p-4 pb-3 border-bottom flex-shrink-0">
        <div class="d-flex w-100 align-items-center justify-content-between">
          <h5 class="modal-title text-xl font-bold text-gray-900">{{ documentTitle }}</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="close.emit()"></button>
        </div>
      </div>
      <!-- Controles de zoom -->
      <div class="d-flex align-items-center justify-content-center gap-4 px-4 py-3 border-bottom flex-shrink-0">
        <button type="button" class="btn btn-outline-secondary" (click)="onZoom('out')" [disabled]="zoomLevel <= 50">
          <span class="me-2">-</span> Alejar
        </button>
        <span class="text-sm font-medium text-gray-600">{{ zoomLevel }}%</span>
        <button type="button" class="btn btn-outline-secondary" (click)="onZoom('in')" [disabled]="zoomLevel >= 200">
          <span class="me-2">+</span> Acercar
        </button>
      </div>
      <!-- Área de previsualización -->
      <div class="flex-grow-1 overflow-auto bg-gray-100 p-4">
        <div class="d-flex justify-content-center">
          <div class="bg-white shadow-lg" [ngStyle]="{
            transform: 'scale(' + (zoomLevel / 100) + ')',
            transformOrigin: 'top center',
            width: (100 / (zoomLevel / 100)) + '%',
            minWidth: '600px'
          }">
            <iframe src="/documento-unipay.pdf" class="w-100" style="height: 800px; border: 0;" [title]="documentTitle"></iframe>
          </div>
        </div>
      </div>
      <!-- Botones inferiores -->
      <div class="d-flex justify-content-between gap-4 p-4 pt-3 border-top bg-white flex-shrink-0">
        <button type="button" class="btn btn-outline-secondary border-gray-300 text-gray-700" (click)="close.emit()">Cancelar</button>
        <button type="button" class="btn text-white bg-primary" (click)="sign.emit()">Firmar</button>
      </div>
    </div>
  </div>
</div> 